import PropTypes from 'prop-types';
import HspDropdown from '../../Dropdowns/HspDropdown/HspDropdown';
import {getDisplayValue} from './chooseTubingUtils';

/**
 * Stateless dropdown for tubing length selection.
 */
function LengthDropdown({choices, design, onSelect: _onSelect, util}) {
  return (
    <HspDropdown
      label={{labelContent: 'Length (L)', labelKey: 'length'}}
      dropdownMenuItems={choices}
      dropdownToggleItems={{
        isDropdownActive: false,
        dropdownText: getDisplayValue('length', design.length, util),
        dropdownClasses: ''
      }}
    />
  );
}

LengthDropdown.propTypes = {
  choices: PropTypes.array.isRequired,
  design: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  util: PropTypes.object.isRequired
};

export default LengthDropdown;
